import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Users, ChevronDown, Clock, AlertTriangle, Phone } from "lucide-react";

const VOCI = [["scadenze", "Incarichi in scadenza o scaduti", Clock], ["ferme", "Pratiche ferme", AlertTriangle], ["richiami", "Da richiamare", Phone]];

function Persona({ p }) {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  return (
    <div className="border border-[var(--border)] rounded-xl bg-white" data-testid={`da-seguire-${p.agente_id || "nessuno"}`}>
      <button data-testid={`da-seguire-apri-${p.agente_id || "nessuno"}`} onClick={() => setOpen(!open)} className="w-full flex items-center gap-3 px-3 py-2.5 text-left">
        <span className="font-semibold text-sm flex-1 truncate">{p.agente}</span>
        {VOCI.map(([k, l, I]) => p[k].length > 0 && <span key={k} title={l} className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full bg-[#F7F7F8] border border-[var(--border)]"><I size={11} />{p[k].length}</span>)}
        <ChevronDown size={15} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-3 pb-3 space-y-3">
        {VOCI.map(([k, l]) => p[k].length > 0 && (
          <div key={k}>
            <div className="text-[11px] font-bold uppercase tracking-wider text-[var(--muted)] mb-1">{l}</div>
            {p[k].map((r) => (
              <button key={`${k}-${r.id}`} data-testid={`da-seguire-riga-${k}-${r.id}`} onClick={() => nav(r.link)} className="w-full text-left flex justify-between gap-2 text-sm px-2 py-1.5 rounded-lg hover:bg-[#F7F7F8]">
                <span className="truncate">{r.titolo}</span><span className="text-xs text-[var(--muted)] shrink-0">{r.info}</span>
              </button>))}
          </div>))}
      </div>}
    </div>
  );
}

export default function DaSeguireTeam() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/da-seguire-team").then((r) => setD(r.data)).catch(() => setD({ persone: [], totale: 0 })); }, []);
  if (!d) return null;
  return (
    <div className="card-immo p-4 mb-6" data-testid="da-seguire-team">
      <div className="flex items-center gap-2 mb-1"><Users size={16} className="text-[#FC82ED]" /><h2 className="font-display font-bold">Da seguire con il team</h2>
        <span className="ml-auto text-xs font-bold px-2 py-0.5 rounded-full bg-[#FC82ED]/15" data-testid="da-seguire-totale">{d.totale}</span></div>
      <p className="text-xs text-[var(--muted)] mb-3">Incarichi in scadenza o già scaduti, pratiche ferme e notizie/incarichi da richiamare, per agente: parlane con loro.</p>
      {d.persone.length === 0 ? <p className="text-sm text-[var(--muted)]">Niente da seguire.</p>
        : <div className="space-y-2">{d.persone.map((p) => <Persona key={p.agente_id || "x"} p={p} />)}</div>}
    </div>
  );
}
